import React from 'react'
import "../../styles/ApprovalCreation.css"
import ApprovalHeader from './ApprovalHeader'
import { useNavigate, useLocation } from "react-router-dom";
import back_arrow from "../../assets/svg/back-arrow.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import { useState, useEffect } from 'react';
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify"
import axios from 'axios'
import axiosInstance from '../../axiosInstance';
import { components } from 'react-select';
import CommonFooter from '../../CommonFooter/CommonFooter';

const ApprovalCreation = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedModule, setSelectedModule] = useState("3");
  const [isEditMode, setIsEditMode] = useState(false);
  const [configId, setConfigId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [jobTypeOptions, setJobTypeOptions] = useState([]);
  const [salesBillingType, setSalesBillingType] = useState(false);
 const [costBillingType, setCostBillingType] = useState(false);
  const [jobTypeInputValue, setJobTypeInputValue] = useState('');
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [vendorInputValue, setVendorInputValue] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [openByArrow, setOpenByArrow] = useState(false);
  const [jobOpenByArrow, setJobOpenByArrow] = useState(false);
  const [deletedLevelIds, setDeletedLevelIds] = useState([]);
  const [projectSelectionType, setProjectSelectionType] = useState("");
  const [approvalLevels, setApprovalLevels] = useState([
    {
      level: 'Level 1',
      selectedUsers: []
    }
  ]);
  const [profitCenterOptions, setProfitCenterOptions] = useState([]);
  const [profitCenter, setProfitCenter] = useState([]);
  const [plantCodeOptions, setPlantCodeOptions] = useState([]);
  const [plantCode, setPlantCode] = useState([]);
  const [regions, setRegions] = useState([]);

  // useEffect(() => {
  //   if (location.state?.config) {
  //     const config = location.state.config;
  //     setIsEditMode(location.state.isEditMode || false);
  //     setConfigId(config.approval_config);
  //     setSelectedModule(config.module);
  //     setSelectedProject({
  //       label: config.project_name,
  //       value: config.project_id
  //     });

  //     // Step 1: Extract user IDs first
  //     const allUserIds = (config.approval_config_lines || []).flatMap(line => line.user_ids || []);

  //     // Step 2: Fetch user labels
  //     axios.get(
  //       `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/approval_config/getusers`,
  //       { params: { ids: allUserIds.join(',') } }
  //     ).then((response) => {
  //       const userMap = {};
  //       response.data.autosuggestion?.forEach((user) => {
  //         userMap[user.value.toString()] = {
  //           value: user.value.toString(),
  //           label: user.label
  //         };
  //       });

  //       // Step 3: Map levels with correct labels
  //       const transformedLevels = (config.approval_config_lines || []).map(line => ({
  //         level: line.level,
  //         selectedDesignations: (line.user_ids || []).map(id =>
  //           userMap[id.toString()] || { value: id.toString(), label: `User ${id}` }
  //         )
  //       }));

  //       setApprovalLevels(transformedLevels.length ? transformedLevels : [{ level: 1, selectedDesignations: [] }]);
  //     }).catch((error) => {
  //       console.error("Error fetching user details:", error);
  //       toast.error("Failed to load user details");
  //     });
  //   }
  // }, [location.state]);

  useEffect(() => {
    if (location.state?.config) {
      const config = location.state.config;
      setIsEditMode(location.state.isEditMode || false);
      setConfigId(config.approval_config);
      setSelectedModule(config.module || "3");
      setSelectedProjects([
        {
          label: config.project_name,
          value: config.project_id
        }
      ]);
      setSalesBillingType(config.sales_billing_type || false);
      setCostBillingType(config.cost_billing_type || false);
      if (config.cost_billing_type &&
        Array.isArray(config.vendor_ids) &&
        config.vendor_ids.length > 0 &&
        Array.isArray(config.vendor_names) && 
        config.vendor_names.length > 0) {
      
      const vendorOptions = config.vendor_names.map(vendor => ({
        value: vendor.id.toString(), 
        label: vendor.label
      }));
      setSelectedVendors(vendorOptions);
      }


      // ✅ Handle Job Types
      const jobTypeIds = Array.isArray(config.job_type_id) ? config.job_type_id.map(id => id.toString()) : [];

      if (jobTypeIds.length > 0) {
        axiosInstance.get('/jobtype/autosuggestion', {
          params: { ids: jobTypeIds.join(',') }
        }).then(response => {
          const options = response.data?.autosuggestion || [];
          const formatted = options.map(job => ({
            value: job.value.toString(),
            label: job.label
          }));

          setJobTypeOptions(formatted);

          // Match selected job types from available options only
          const selected = jobTypeIds
            .map(id => formatted.find(j => j.value === id))
            .filter(Boolean); // Remove unmatched/falsy

          setSelectedJobs(selected);
        }).catch(error => {
          console.error("Job types load error:", error);
          setSelectedJobs([]);
        });
      } else {
        setSelectedJobs([]);
        setJobTypeOptions([]);
      }


      // ✅ Handle Users Separately
      const allUserIds = (config.approval_config_lines || []).flatMap(line => line.user_ids || []);

      axiosInstance.get('/approval_config/getusers', {
        params: { ids: allUserIds.join(',') }
      }).then((response) => {
        const userMap = {};
        response.data.autosuggestion?.forEach((user) => {
          userMap[user.value.toString()] = {
            value: user.value.toString(),
            label: user.label
          };
        });

        const transformedLevels = (config.approval_config_lines || []).map(line => ({
          approval_config_line_id: line.approval_config_line_id,
          level: line.level,
          selectedUsers: (line.user_ids || []).map(id =>
            userMap[id.toString()] || { value: id.toString(), label: `User ${id}` }
          )
        }));

        setApprovalLevels(transformedLevels.length ? transformedLevels : [{ approval_config_line_id: null, level: 1, selectedUsers: [] }]);

        if (config.project_selection_type === "profit_center") {
          setProjectSelectionType("profit_center");
          setProfitCenter([
            {
              value: config.profit_centre_id,
              label: config.profit_centre
            }
          ]);
        }

        if (config.project_selection_type === "plant_code") {
          setProjectSelectionType("plant_code");
          setPlantCode([
            {
              value: config.plant_code_id,
              label: config.plant_code
            }
          ]);
        }

        if (config.project_selection_type === "region") {
          setProjectSelectionType("region");
          setRegions([
            {
              value: config.region,
              label: config.region
            }
          ]);
        }

      }).catch((error) => {
        console.error("Error fetching user details:", error);
        toast.error("Failed to load user details");
      });
    }
  }, [location.state]);




  const loadUserOptions = async (inputValue) => {
    try {
      // const response = await axios.get(
      //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/approval_config/getusers`,
      //   {
      //     params: { term: inputValue || '' } // Ensure query is never undefined
      //   }
      // );

      const response = await axiosInstance.get(
        `/approval_config/getusers`,
        {
          params: { term: inputValue || '' }
        }
      );

      // Check if response has autosuggestion array
      if (response.data?.autosuggestion) {
        return response.data.autosuggestion.map((user) => ({
          label: user.label,
          value: user.value.toString() // Convert to string if needed
        }));
      }
      return []; // Return empty array if data format is unexpected
    } catch (error) {
      console.error("Error loading user options:", error);
      return []; // Return empty array on error
    }
  };

  const addNewLevel = () => {
    const newLevelNumber = approvalLevels.length + 1;
    setApprovalLevels([
      ...approvalLevels,
      {
        level: `Level ${newLevelNumber}`,
        selectedUsers: []
      }
    ]);
  };


  const CustomMenuList = (props) => {
    const { options, selectProps } = props;
    const { value, onChange } = selectProps;

    const allSelected =
      options.length > 0 && value?.length === options.length;

    const handleSelectAll = () => {
      onChange(options);
    };

    const handleDeselectAll = () => {
      onChange([]);
    };

    return (
      <components.MenuList {...props}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 10px",
            borderBottom: "1px solid #e5e7eb",
            background: "#f9fafb",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          <span
            style={{ cursor: "pointer", color: "#454CF2" }}
            onClick={handleSelectAll}
          >
            Select All
          </span>
          <span
            style={{ cursor: "pointer", color: "#454CF2" }}
            onClick={handleDeselectAll}
          >
            Deselect All
          </span>
        </div>

        {props.children}
      </components.MenuList>
    );
  };

  const CustomOption = (props) => {
    const { isSelected, label } = props;

    return (
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            style={{ accentColor: "#454CF2" }}
          />
          <span>{label}</span>
        </div>
      </components.Option>
    );
  };

  const projectSelectKey = `${projectSelectionType}-${profitCenter.map(p => p.value).join("-")}-${plantCode.map(p => p.value).join("-")}-${regions.map(r => r.value).join("-")}`;

  const loadProjectOptions = async (inputValue) => {
    try {
      let apiUrl = "/approval_config/get_approvalconfig_projects";

      const params = {
        term: inputValue || "",
        type: "not_mapped",
      };
      if (projectSelectionType) {
        params.selection_type =
          projectSelectionType === "profit_center"
            ? "profit_centre"
            : projectSelectionType;

        if (projectSelectionType === "profit_center") {
          if (!profitCenter.length) return [];
          params.reference_id = profitCenter.map(p => p.value);
        }

        if (projectSelectionType === "plant_code") {
          if (!plantCode.length) return [];
          params.reference_id = plantCode.map(p => p.value);
        }

        if (projectSelectionType === "region") {
          if (!regions.length) return [];
          params.region = regions.map(r => r.value);
        }
      }

      const res = await axiosInstance.get(apiUrl, { params });

      return (res.data?.autosuggestion || []).map(p => ({
        label: p.label,
        value: p.value,
      }));
    } catch (error) {
      console.error("Project suggestion error:", error);
      return [];
    }
  };

  const loadVendorOptions = async (inputValue) => {
    try {
      const response = await axiosInstance.get("/vendor/autosuggestion",
        { params: { term: inputValue } }
      );
      const vendor = response.data?.autosuggestion || [];

      if (openByArrow) {
        return vendor.map(p => ({
          label: p.label,
          value: p.value.toString(),
        }));
      }
      return vendor.slice(0, 10).map(p => ({
        label: p.label,
        value: p.value.toString(),
      }));
    } catch (error) {
      console.error("Vendor suggestion error:", error);
    }
  };

  const handleSubmit = async () => {
    if (!selectedProjects || selectedProjects.length === 0) {
      toast.error("Please select at least one project");
      return;
    }

    if (!selectedModule) {
      toast.error("Please select a Module");
      return;
    }

    if (!salesBillingType && !costBillingType) {
      toast.error("Please select at least one billing type");
      return;
    }

    for (let i = 0; i < approvalLevels.length; i++) {
      const level = approvalLevels[i];

      if (!level.level) {
        toast.error(`Please enter level for row ${i + 1}`);
        return;
      }
      if (!level.selectedUsers || level.selectedUsers.length === 0) {
        toast.error(`Please select at least one user for ${level.level}`);
        return;
      }
    }

    try {
      let payload;
      let response;

      if (isEditMode && configId) {
        payload = {
          id: configId,
          project_id: Number(selectedProjects[0].value),
          module: selectedModule,
          sales_billing_type: salesBillingType,
          cost_billing_type: costBillingType,
          job_type_id: selectedJobs.map(job => Number(job.value)),
          approval_config_line: approvalLevels.map(level => ({
            id:level.approval_config_line_id,
            level: level.level,
            user_ids: level.selectedUsers.map(user => Number(user.value))
          })),
          ...(costBillingType && selectedVendors.length > 0 && {
            vendor_ids: selectedVendors.map(v => Number(v.value))
          })
        };

        response = await axiosInstance.put(
          "/approval_config/update",
          payload
        );

      } else {
        payload = {
          project_ids: selectedProjects.map(p => Number(p.value)),
          module: selectedModule,
          sales_billing_type: salesBillingType,
          cost_billing_type: costBillingType,
          job_type_id: selectedJobs.map(job => Number(job.value)),
          approval_config_line: approvalLevels.map(level => ({
            level: level.level,
            user_ids: level.selectedUsers.map(user => Number(user.value))
          })),
          ...(costBillingType && selectedVendors.length > 0 && {
            vendor_ids: selectedVendors.map(v => Number(v.value))
          })
        };

        response = await axiosInstance.post(
          "/approval_config/save",
          payload
        );
      }

      if (response.data.success) {
        toast.success(
          `Configuration ${isEditMode ? "updated" : "created"} successfully!`
        );
        setTimeout(() => navigate("/approval_config"), 1500);
      } else {
        throw new Error(response.data.message || "Operation failed");
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response?.data?.message || error.message);
    }
  };

  const loadJobTypes = async (inputValue) => {
    try {

      const res = await axiosInstance.get(`/jobtype/autosuggestion`, {
        params: { term: inputValue || '' }
      }
      );
      const options = res.data?.autosuggestion || [];

      if (jobOpenByArrow) {
        return options.map(p => ({
          label: p.label,
          value: p.value.toString(),
        }));
      }
      return options.map(item => ({
        label: item.label,
        value: item.value.toString(),
      }));
    } catch (error) {
      console.error("Job type suggestion error:", error);
      return [];
    }
  };

  const handleDeleteLevel = (index) => {
    if (approvalLevels.length === 1) {
      toast.error("At least one approval level is required");
      return;
    }

    const levelToDelete = approvalLevels[index];

    if (levelToDelete?.approval_config_line_id) {
      setDeletedLevelIds(prev => [...prev, levelToDelete.approval_config_line_id]);
    }

    setApprovalLevels(prev => prev.filter((_, i) => i !== index));
  };

  const loadProfitCenters = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get("/projects/get_profit_centre",
        { params: { term: inputValue || "" } }
      );

      const options = (res.data?.autosuggestion || []).map(item => ({
        value: item.value,
        label: item.label
      }));
      if (!inputValue) {
        setProfitCenterOptions(options);
      }

      callback(options);
    } catch (err) {
      console.error("Profit center error", err);
      callback([]);
    }
  };

  const loadPlantCode = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get("/plant_code/autosuggestion",
        { params: { term: inputValue || "" } }
      );

      const options = (res.data?.autosuggestion || []).map(item => ({
        value: item.value,
        label: item.label
      }));
      if (!inputValue) {
        setPlantCodeOptions(options);
      }
      callback(options);
    } catch (err) {
      console.error("Profit center error", err);
      callback([]);
    }
  };

  const validateProjectDependency = () => {
    if (projectSelectionType === "profit_center" && !profitCenter.length) {
      toast.warning("Please select Profit Center first");
      return false;
    }

    if (projectSelectionType === "plant_code" && !plantCode.length) {
      toast.warning("Please select Plant Code first");
      return false;
    }

    if (projectSelectionType === "region" && !regions.length) {
      toast.warning("Please select Region first");
      return false;
    }

    return true;
  };


  return (
    <>
      <ApprovalHeader onSearch={null} disableSearch={true}/>
      <div className='approval-creation'>
        <div className="approval-creation-header">
          <div className="approval-creation-header-left">
            <img src={back_arrow} alt="Back Arrow" onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }} />
            <p className="approval-creation-header-head">New Approval Configuration</p>
          </div>
          <div className="approval-creation-header-right">
            <button className="cancel_btn" onClick={() => navigate(-1)}>Cancel</button>
            <button
              className="submit_btn"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : configId ? 'Update' : 'Submit'}
            </button>
          </div>
        </div>

        <div className="approval-creation-content">
          <div
            className="approval-creation-grid-container"
            style={{
              display: "grid",
              gridTemplateColumns: isEditMode
                ? "0.8fr 0.4fr 0.4fr 1fr"
                : projectSelectionType
                  ? "0.6fr 0.5fr 0.5fr 0.2fr"
                  : "1fr 1fr 0.5fr 0.2fr",
              gap: "15px",
            }}
          >
            {!isEditMode && (
              <div className="approval-creation-field">
                <p className="approval-creation-text">Project Selection Type</p>
                <div className="approval-creation-pill-radio-group">
                  {[
                    { label: "Plant Code", value: "plant_code" },
                    { label: "Profit Center", value: "profit_center" },
                    { label: "Region", value: "region" }
                  ].map(item => (
                    <div
                      key={item.value}
                      role="radio"
                      aria-checked={projectSelectionType === item.value}
                      className={`approval-creation-pill-radio ${projectSelectionType === item.value ? "active" : ""
                        }`}
                      onClick={() => {
                        if (projectSelectionType === item.value) {
                          setProjectSelectionType("");
                          setProfitCenter([]);
                          setPlantCode([]);
                          setRegions([]);
                          setSelectedProjects([]);
                        } else {
                          setProjectSelectionType(item.value);
                          setProfitCenter([]);
                          setPlantCode([]);
                          setRegions([]);
                          setSelectedProjects([]);
                        }
                      }}
                    >
                      <input
                        type="radio"
                        name="project_selection_type"
                        checked={projectSelectionType === item.value}
                        readOnly
                      />

                      <span className="approval-creation-pill-label">
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {projectSelectionType === "profit_center" && (
              <div className="approval-creation-field">
                <p className="approval-creation-text">Profit Center<span style={{ color: 'red' }}>*</span></p>
                <div >
                  <AsyncSelect
                    isMulti
                    value={profitCenter}
                    components={{
                      MenuList: CustomMenuList,
                      Option: CustomOption
                    }}
                    loadOptions={loadProfitCenters}
                    cacheOptions
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    noOptionsMessage={() => null}
                    onFocus={() => {
                      if (profitCenterOptions.length === 0) {
                        loadProfitCenters("", () => { });
                      }
                    }}
                    onChange={(selected) => {
                      setProfitCenter(selected || []);
                      setSelectedProjects([]);
                    }}
                    defaultOptions={profitCenterOptions}
                    placeholder="Search project..."
                    isClearable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: '35px',
                        borderRadius: '12px',
                        fontSize: '13px',
                        width: '100%',
                        borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                        boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                        '&:hover': {
                          borderColor: '#454CF2'
                        }
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: '13px',
                        color: '#9AA4B2',
                      }),
                      container: (base) => ({
                        ...base,
                        width: '100%'
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: '13px'
                      }),
                      menuList: base => ({
                        ...base,
                        maxHeight: '250px',
                        overflowY: 'auto',
                        padding: 0
                      }),
                      option: (base, { isFocused }) => ({
                        ...base,
                        backgroundColor: isFocused ? "#f2f2f2" : "#fff",
                        color: "#333",
                        cursor: "pointer",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: "35px",
                        height: "40px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        flexWrap: "wrap",
                        alignItems: "center",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                      }),
                    }}
                  />
                </div>
              </div>
            )}
            {projectSelectionType === "plant_code" && (
              <div className="approval-creation-field">
                <p className="approval-creation-text">Plant Code<span style={{ color: 'red' }}>*</span></p>
                <div >
                  <AsyncSelect
                    isMulti
                    value={plantCode}
                    components={{
                      MenuList: CustomMenuList,
                      Option: CustomOption
                    }}
                    loadOptions={loadPlantCode}
                    onChange={(selected) => {
                      setPlantCode(selected || []);
                      setSelectedProjects([]);
                    }}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    placeholder="Search Plant Code..."
                    cacheOptions
                    defaultOptions={plantCodeOptions}
                    onFocus={() => {
                      if (plantCodeOptions.length === 0) {
                        loadPlantCode("", () => { });
                      }
                    }}
                    isClearable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: '35px',
                        borderRadius: '12px',
                        fontSize: '13px',
                        width: '100%',
                        borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                        boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                        '&:hover': {
                          borderColor: '#454CF2'
                        }
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: '13px',
                        color: '#9AA4B2',
                      }),
                      container: (base) => ({
                        ...base,
                        width: '100%'
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: '13px'
                      }),
                      menuList: base => ({
                        ...base,
                        maxHeight: '250px',
                        overflowY: 'auto',
                        padding: 0
                      }),
                      option: (base, { isFocused }) => ({
                        ...base,
                        backgroundColor: isFocused ? "#f2f2f2" : "#fff",
                        color: "#333",
                        cursor: "pointer",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: "35px",
                        height: "40px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        flexWrap: "wrap",
                        alignItems: "center",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                      }),
                    }}
                  />
                </div>
              </div>
            )}
            {projectSelectionType === "region" && (
              <div className="approval-creation-field">
                <p className="approval-creation-text">
                  Region <span style={{ color: "red" }}>*</span>
                </p>

                <Select
                  isMulti
                  value={regions}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(selected) => {
                    setRegions(selected || []);
                    setSelectedProjects([]);
                  }}
                  options={[
                    { label: "East", value: "east" },
                    { label: "West", value: "west" },
                    { label: "South", value: "south" },
                    { label: "North", value: "north" }
                  ]}
                  components={{
                    MenuList: CustomMenuList,
                    Option: CustomOption
                  }}
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: '35px',
                      borderRadius: '12px',
                      fontSize: '13px',
                      width: '100%',
                      borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                      '&:hover': {
                        borderColor: '#454CF2'
                      }
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: '13px',
                      color: '#9AA4B2',
                    }),
                    container: (base) => ({
                      ...base,
                      width: '100%'
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: '13px'
                    }),
                    menuList: base => ({
                      ...base,
                      maxHeight: '250px',
                      overflowY: 'auto',
                      padding: 0
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      backgroundColor: isFocused ? "#f2f2f2" : "#fff",
                      color: "#333",
                      cursor: "pointer",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      maxHeight: "35px",
                      height: "40px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      flexWrap: "wrap",
                      alignItems: "center",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                    }),
                  }}
                />
              </div>
            )}
            <div className="approval-creation-field">
              <p className="approval-creation-text">Project <span style={{ color: 'red' }}>*</span></p>
              <div >
                <AsyncSelect
                  isMulti
                  cacheOptions
                  defaultOptions={true}
                  key={projectSelectKey}
                   isDisabled={isEditMode} 
                  loadOptions={loadProjectOptions}
                  onChange={(selectedOption) => { setSelectedProjects(selectedOption) }}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onMenuOpen={() => validateProjectDependency()}
                  onFocus={() => setOpenByArrow(false)}
                  noOptionsMessage={() => null}
                  components={{
                    MenuList: CustomMenuList,
                    Option: CustomOption
                  }}
                  value={selectedProjects}
                  placeholder="Search project..."
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: '35px',
                      borderRadius: '12px',
                      fontSize: '13px',
                      width: '100%',
                      borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                      '&:hover': {
                        borderColor: '#454CF2'
                      }
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: '13px',
                      color: '#9AA4B2',
                    }),
                    container: (base) => ({
                      ...base,
                      width: '100%'
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: '13px'
                    }),
                    menuList: base => ({
                      ...base,
                      maxHeight: '250px',
                      overflowY: 'auto',
                      padding: 0
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      backgroundColor: isFocused ? "#f2f2f2" : "#fff",
                      color: "#333",
                      cursor: "pointer",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      maxHeight: "35px",
                      height: "40px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      flexWrap: "wrap",
                      alignItems: "center",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                    }),
                  }}
                />
              </div>
            </div>
            <div className="approval-creation-field narrow-field">
              <p className="approval-creation-text">Module <span style={{ color: 'red' }}>*</span></p>
              <select
                className="approval-creation-dropdown"
                value={selectedModule}
                onChange={(e) => setSelectedModule(e.target.value)}
              >
                {/* <option value="">Select</option> */}
                <option value="3">Invoice</option>
              </select>
            </div>
            <div className="approval-creation-field narrow-field">
              <p className="approval-creation-text">Billing Type <span style={{ color: 'red' }}>*</span></p>
              <div style={{ display: 'flex', gap: '13px' }}>
                {/* Sales Box */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 16px',
                  border: '1px solid #ccc',
                  height: '35px',
                  borderRadius: '10px',
                  backgroundColor: '#ffffff',
                  fontSize: '13px',
                  fontFamily: 'Work Sans'
                }}>
                  <input
                    type="checkbox"
                    checked={salesBillingType}
                    onChange={(e) => setSalesBillingType(e.target.checked)}
                  />
                  <span>Sales</span>
                </div>

                {/* Cost Box */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 16px',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  backgroundColor: '#ffffff',
                  height: '35px',
                  fontSize: '13px',
                  fontFamily: 'Work Sans'
                }}>
                  <input
                    type="checkbox"
                    checked={costBillingType}
                    onChange={(e) => setCostBillingType(e.target.checked)}
                  />
                  <span>Cost</span>
                </div>

              </div>
            </div>
            <div className="approval-creation-field wide-field">
              <p className="approval-creation-text">Job type</p>
              <div style={{ width: '100%' }}>
                <AsyncSelect
                  isMulti
                  value={selectedJobs}
                  defaultOptions
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  inputValue={jobTypeInputValue}
                  onChange={(selectedOptions) => {
                    setSelectedJobs(selectedOptions || []);
                  }}
                  onMenuOpen={() => setJobOpenByArrow(true)}
                  onFocus={() => setJobOpenByArrow(false)}
                  onInputChange={setJobTypeInputValue}
                  loadOptions={loadJobTypes}
                  placeholder="Search and select job types..."
                  cacheOptions
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? "No job types found" : "Type to search job types"
                  }
                  loadingMessage={() => "Searching..."}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      width: '100%',
                      minHeight: '37px',
                      borderRadius: '12px',
                      fontSize: '14px',
                      borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                      '&:hover': {
                        borderColor: '#454CF2'
                      }
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: '13px',
                      color: '#9AA4B2',
                    }),
                    container: (base) => ({
                      ...base,
                      width: '100%'
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: '13px',
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: '#F0F4F8',
                      borderRadius: '4px',
                      padding: '2px 6px',
                      margin: '2px'
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: '#19324C',
                      fontSize: '12px',
                      fontWeight: 500
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      maxHeight: "35px",
                      height: "40px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      flexWrap: "wrap",
                      alignItems: "center",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: '#19324C',
                      ':hover': {
                        backgroundColor: 'transparent',
                        color: '#ff0000'
                      }
                    })
                  }}
                  components={{
                    MenuList: CustomMenuList,
                    Option: CustomOption,
                    DropdownIndicator: null,
                    IndicatorSeparator: null,
                  }}
                />
              </div>
            </div>
            {costBillingType && (
              <div className="approval-creation-field wide-field">
                <p className="approval-creation-text">Vendor</p>
                <div style={{ width: '100%' }}>
                  <AsyncSelect
                    isMulti
                    cacheOptions
                    defaultOptions
                    inputValue={vendorInputValue}
                    onInputChange={setVendorInputValue}
                    onMenuOpen={() => setOpenByArrow(true)}
                    onFocus={() => setOpenByArrow(false)}
                    loadOptions={loadVendorOptions}
                    onChange={setSelectedVendors}
                    value={selectedVendors}
                    placeholder="Search vendor..."
                    closeMenuOnSelect={false}
                    isClearable
                    hideSelectedOptions={false}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: '37px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                        boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                        display: 'flex',
                        flexWrap: 'nowrap',
                        overflowX: 'auto',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        '&::-webkit-scrollbar': {
                          display: 'none'
                        },
                        '&:hover': {
                          borderColor: '#454CF2'
                        }
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: "35px",
                        height: "40px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        flexWrap: "wrap",
                        alignItems: "center",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: '#F0F4F8',
                        borderRadius: '4px',
                        padding: '2px 6px',
                        margin: '2px',
                        maxWidth: '280px',         
                        overflow: 'hidden'
                      }),

                      multiValueLabel: (base) => ({
                        ...base,
                        color: '#19324C',
                        fontSize: '12px',
                        fontWeight: 500,
                        overflow: 'hidden',         
                        textOverflow: 'ellipsis',    
                        whiteSpace: 'nowrap'        
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: '#19324C',
                        ':hover': {
                          backgroundColor: 'transparent',
                          color: '#ff0000'
                        }
                      }),
                      container: (base) => ({
                        ...base,
                        width: '100%'
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: '12px'
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: '13px',
                        color: '#9AA4B2',
                      }),
                    }}
                    components={{
                      MenuList: CustomMenuList,
                      Option: CustomOption,
                      DropdownIndicator: null,
                      IndicatorSeparator: null,
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          <div className='approval-creation-approval-flow'>
            <div className='approval-creation-add-charges-section'>
              <h3 className='approval-creation-add-charges-heading'>Approval Flow</h3>

              {approvalLevels.map((level, levelIndex) => (
                <div key={level.approval_config_line_id} className='approval-creation-add-charges-content'>
                  <div className='approval-creation-grid'>
                    <div className='approval-creation-field'>
                      <label className='approval-creation-level' style={{ fontWeight: '600', color: 'black' }}>Level <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="number"
                        className='approval-creation-add-charges-input'
                        value={level.level}
                        onChange={(e) => {
                          const newLevel = parseInt(e.target.value);
                          const updatedLevels = [...approvalLevels];
                          updatedLevels[levelIndex].level = newLevel;
                          setApprovalLevels(updatedLevels);
                        }}
                        min="1"
                        required

                      />
                    </div>

                    <div style={{ width: '100%' }}>
                      <label style={{
                        fontSize: '12px',
                        fontWeight: 600,
                        display: 'block',
                        color: 'black'
                      }}>
                        Users <span style={{ color: 'red' }}>*</span>
                      </label>
                      <AsyncSelect
                        className="user-select-width"
                        isMulti
                        cacheOptions
                        defaultOptions
                        style={{ width: '100%' }}
                        loadOptions={loadUserOptions}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        value={level.selectedUsers}
                        onChange={(selected) => {
                          const updatedLevels = [...approvalLevels];
                          updatedLevels[levelIndex].selectedUsers = selected || [];
                          setApprovalLevels(updatedLevels);
                        }}
                        components={{
                          MenuList: CustomMenuList,
                          Option: CustomOption
                        }}
                        placeholder="Search users..."
                        noOptionsMessage={() => null}
                        loadingMessage={() => "Loading users..."}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: '40px',
                            borderRadius: '12px',
                            borderColor: state.isFocused ? '#19324C' : '#DCDFE4',
                            boxShadow: state.isFocused ? '0 0 0 1px #19324C' : 'none',
                            '&:hover': {
                              borderColor: '#19324C'
                            }
                          }),
                          placeholder: (base) => ({
                            ...base,
                            fontSize: '13px',
                            color: '#9AA4B2',
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                            fontSize: '13px'
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: '#F0F4F8',
                            borderRadius: '16px'
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: '#19324C',
                            fontSize: '12px',
                            fontWeight: 500
                          }),
                          menuList: base => ({
                            ...base,
                            maxHeight: '250px',
                            overflowY: 'auto',
                            padding: 0
                          }),
                        }}
                      />
                    </div>

                    <div className="approval-delete-icon">
                      <img
                        src={delete_icon}
                        alt="Delete"
                        onClick={() => handleDeleteLevel(levelIndex)}
                      />
                    </div>
                  </div>
                </div>
              ))}

              <div className="add-charges-add-section" onClick={addNewLevel}>
                <img src={plus_icon} alt="Add new charge" />
                <span>Add New</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <CommonFooter />
    </>
  )
}

export default ApprovalCreation